import eventbus from 'tiny-emitter/instance';

export default class Selection {
  selectionStarted = false;
  constructor(app) {
    this.app = app;
    this.svg = this.app.svg;
    this.setup();
    this.setupEventListeners();

    return this;
  }

  setup() {
    this.bbox = Object.create(null);
    this.selectionRect = this.svg.rect(0, 0);
  }

  setupEventListeners() {
    this.svg.on('mousedown', this.handleMouseDown, this);
  }

  addMouseListeners() {
    this.svg.on('mousemove', this.handleMouseMove, this);
    this.svg.on('mouseup', this.handleMouseUp, this);
  }

  removeMouseListeners() {
    this.svg.off('mousemove', this.handleMouseMove);
    this.svg.off('mouseup', this.handleMouseUp);
  }

  handleMouseDown(e) {
    this.mouseDownCoords = { x: e.clientX, y: e.clientY };
    if (e.button !== 0) return;
    if ((!this.app.isIE && e.detail >= 2) || (this.app.isIE && e.detail > 10)) {
      eventbus.emit('selection:multiclick', e.detail);
      e.stopPropagation();
      e.preventDefault();
      return;
    }
    if (this.selectionStarted) return;
    this.addMouseListeners();
    e.preventDefault();
    this.moved = false;
    this.selectionStarted = true;
    const { x, y } = this.app.getTransformedCoords(e);
    this.bbox.initX = x;
    this.bbox.initY = y;

    this.selectionRect
      .attr({
        x: this.bbox.initX,
        y: this.bbox.initY,
        width: 1,
        height: 1,
      })
      .addClass('selector')
      .front();
    eventbus.emit('selection:started', this.selectionRect);
  }

  handleMouseMove(e) {
    // attempt to fix mouse move firing on click in safari and causing wrong selection
    if (this.selectionStarted && e.clientX === this.mouseDownCoords.x && e.clientY === this.mouseDownCoords.y) {
      return;
    }
    if (this.selectionStarted === false) {
      this.removeMouseListeners();
      return;
    }
    e.preventDefault();
    const { x, y } = this.app.getTransformedCoords(e);
    this.adjustBBox(this.bbox.initX, this.bbox.initY, x, y);
    this.moved = true;
    this.selectionRect.attr({
      x: this.bbox.x,
      y: this.bbox.y,
      width: this.bbox.width,
      height: this.bbox.height,
    });
    eventbus.emit('selection:expanded', this.selectionRect);
  }

  handleMouseUp(e) {
    if (this.selectionStarted === false) {
      this.removeMouseListeners();
      return;
    }
    e.preventDefault();
    this.selectionStarted = false;
    eventbus.emit('selection:finished', this.selectionRect, this.moved);
    this.selectionRect.size(0, 0);
    this.moved = false;
    this.removeMouseListeners();
  }

  adjustBBox(x, y, x2, y2) {
    this.bbox.x = x;
    this.bbox.y = y;
    this.bbox.x2 = x2;
    this.bbox.y2 = y2;

    if (x2 <= x && y2 >= y) {
      this.bbox.x = x2;
      this.bbox.x2 = x;
    } else if (y2 <= y && x2 >= x) {
      this.bbox.y = y2;
      this.bbox.y2 = y;
    } else if (y2 < y && x2 < x) {
      this.bbox.x = x2;
      this.bbox.x2 = x;
      this.bbox.y = y2;
      this.bbox.y2 = y;
    }
    this.bbox.width = this.bbox.x2 - this.bbox.x;
    this.bbox.height = this.bbox.y2 - this.bbox.y;
  }

  destroyEventListeners() {
    this.removeMouseListeners();
    this.svg.off('mousedown', this.handleMouseDown);
  }

  destroyObjects() {
    this.selectionRect.remove();
  }

  destroy() {
    this.destroyEventListeners();
    this.destroyObjects();
  }
}
